module.exports = __webpack_public_path__ + "img/KinokoTable18.19d2661a.jpg";